import { gql } from "@apollo/client"

export const GET_ORGANIZATION_ADMINS_COUNT_QUERY = gql`
  query getOrganizationAdminsCount($data: CountAdminsRequest) {
    organizationAdmin {
      count(data: $data) {
        count
        activeCount
      }
    }
  }
`
